<script>
import Logo from './../../../components/logo'
import Donate from './tabs/donate.vue'
import ViewPlans from './tabs/view-plans.vue'
import analyticsService from './../../../services/analytics-service'
import paywallTracker from '@services/mixpanel/paywall-tracker'
import {
    WALL_TYPES,
    PRESENTATION_TYPES,
    TRIGGER_REASONS,
    ENTRY_POINTS,
    CTA_TYPES,
    DISMISS_METHODS
} from '@services/mixpanel/analytics-spec'

export default {
    name: 'PremiumViewPlans',

    components: { Logo, Donate, ViewPlans },

    props: {
        mainComponent: {
            type: String,
            default: 'ViewPlans',
        },
    },

    computed: {
        isLoggedIn() {
            return this.$store.getters['auth/loggedIn']
        },
        plans() {
            return this.$store.getters['premium/sortedPremiumPlans']
        },
        currentSubscription() {
            return this.$store.getters['premium/activeSubscription']
        },
        entitledFreeTrial() {
            return !this.$store.getters['premium/hasEverBeenPremium']
        },
        filteredPlans() {
            return this.plans.filter(plan => plan.active === 1)
        },
        tabs() {
            return [
                {
                    to: `/premium/view-plans`,
                    label: 'Premium',
                },
                {
                    to: `/premium/donate`,
                    label: 'Donate',
                },

            ]
        },
    },

    mounted() {
        this._trackWallShown()
    },

    methods: {
        _trackWallShown() {
            const entryPoint = this._getEntryPoint()
            paywallTracker.onWallShown({
                wallType: WALL_TYPES.VIEW_PLANS,
                presentation: PRESENTATION_TYPES.PAGE,
                triggerReason: TRIGGER_REASONS.USER_INITIATED,
                entryPoint
            })
        },
        _getEntryPoint() {
            const referrer = document.referrer || ''
            const query = this.$route.query
            if (query.from === 'topbar') return ENTRY_POINTS.TOP_BAR
            if (query.from === 'sidebar') return ENTRY_POINTS.SIDEBAR
            if (query.from === 'modal') return ENTRY_POINTS.PREMIUM_UPSELL_MODAL
            if (query.from === 'settings') return ENTRY_POINTS.SETTINGS_AUDIO_QUALITY
            if (query.from === 'account') return ENTRY_POINTS.ACCOUNT_MENU
            if (referrer.includes('/settings')) return ENTRY_POINTS.SETTINGS_AUDIO_QUALITY
            if (referrer.includes('/account')) return ENTRY_POINTS.ACCOUNT_MENU
            return ENTRY_POINTS.DIRECT_NAVIGATION
        },
        selectPlan(plan) {
            paywallTracker.onCtaTapped(CTA_TYPES.VIEW_PLANS)
            analyticsService.premiumUpsellPlanSelected(plan.id)
            this.$router.push({
                path: `${this.$route.path.includes('offer') ? '/offer' : ''}/premium/select-payment/${plan.id}`,
            })
        },
        selectAmount(amount) {
            this.selectedDonationAmount = amount
        },
        handleDismiss() {
            paywallTracker.onWallDismissed(DISMISS_METHODS.CLOSE)
            this.$router.push({ name: 'home' })
        },
    },
}
</script>

<template>
    <div>
        <BaseContent v-if="tabs.length">
            <BaseSection padded>
                <Logo
                    :is-linked-to-home="false"
                    size="m"
                />
            </BaseSection>
            <BaseTabPanel
                :tabs="tabs"
                :class="$style.tabs"
                is-unpadded
                address-navigation
            />
            <BaseContent>
                <component
                    :is="mainComponent"
                    :plans="filteredPlans"
                    :current-subscription="currentSubscription"
                    :is-logged-in="isLoggedIn"
                    :is-entitled-free-trial="entitledFreeTrial"
                    @selectAmount="selectAmount"
                    @onAction="selectPlan"
                />
            </BaseContent>
            <BaseSection padded>
                <div
                    :class="$style.escapeUrl"
                    @click="handleDismiss"
                >No, thanks. I like ads and low quality audio.</div>
            </BaseSection>
        </BaseContent>
    </div>
</template>

<style lang="scss" module>
@use '@design' as *;

.escapeUrl {
    @extend %contentSubtitleM;

    margin-top: $s-xxl;
    text-align: center;
    text-decoration: underline;
    cursor: pointer;
}

@include tablet {
    .escapeUrl {
        text-align: left;
    }
}
</style>
